import { App } from '@/app';
import '@/config/sentry';
import { FlashProvider, InquiryProvider } from '@/providers';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './infrastructure';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <FlashProvider>
      <InquiryProvider>
        <App />
      </InquiryProvider>
    </FlashProvider>
  </QueryClientProvider>
);
